import { FaBookOpen } from "react-icons/fa";
import CatalogoTable from "./CatalogoTable";

// Registro de clases de Escuela Dominical por fecha (Niños, Segundo Tiempo,
// Adultos), con tema, maestro y título de la lección. Usa el sistema
// genérico de catálogos: la tabla es monte.lecciones_clase.
export default function ClasesDominicalLeccionesAdmin() {
  return (
    <CatalogoTable
      tabla="lecciones_clase"
      nombre="Clases de Escuela Dominical"
      nombreSingular="registro"
      descripcion="Registro por fecha de las clases de Escuela Dominical: Niños, Segundo Tiempo y Adultos."
      icono={FaBookOpen}
    />
  );
}
